
<template>
  <div class="page6 animated fadeIn">

    <div class="modal" v-show="modal">
      <h3>{{items.modal.title}}</h3>
      <hr />
      <p class="instructions" v-html="items.modal.text"></p>
      <p class="instructions" v-html="items.activity.instructions"></p>
      <button class="button forward" @click="closeModal">{{items.modal.button}}</button>
    </div>

    <div class="modal final" v-show="final">
      <h3>{{items.feedback.title}}</h3>
      <hr />
      <p class="instructions" v-html="items.feedback.text"></p>
      <button class="button forward" @click="showReview">{{items.feedback.button}}</button>
    </div>

    <div class="container" v-show="!review">

      <!-- DASHED LINES -->
      <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 viewBox="0 0 361.3 234.5" style="enable-background:new 0 0 361.3 234.5;" xml:space="preserve">
      <g>
      	<g>
      		<path class="st0" d="M0.6,139.2c0,0,0.2-0.3,0.6-0.8"/>
      		<path class="st1" d="M2.3,136.8C15.3,119.1,100.5,10.4,252.6,1.3"/>
      		<path class="st0" d="M253.6,1.3c0.3,0,0.7,0,1-0.1"/>
      	</g>
      </g>
      <path class="st2" d="M312.1,0.7c0,0,20,5,21,21"/>
      <path class="st2" d="M281.1,21.7c0,0,2,25-30,38"/>
      <path class="st2" d="M260.1,77.7c0,0,17,15,6,34"/>
      <path class="st2" d="M223.1,127.7c0,0-35,5-38,46"/>
      <path class="st2" d="M151.1,169.7c0,0-3-17-28-19"/>
      <path class="st2" d="M97.1,173.7c0,0,14,60,107,60"/>
      <path class="st2" d="M260.1,233.7c0,0,33-28,6-74"/>
      <path class="st2" d="M290.1,132.7c0,0,37-1,47,37"/>
      <path class="st2" d="M290.1,127.7c0,0,24-27,71-16"/>
      </svg>

      <!-- ANIMATION -->
      <activate v-if="active"></activate>

      <div class="warning animated slideInRight" v-show="kpiWarn"><i class="fas fa-exclamation"></i>{{items.activity.warning}}</div>
      <dashboard :id="id" :dashValues="dashValues" :units="units" v-show="!modal">
        <div slot="warnings">
          <!-- WARNINGS -->
          <i class="fas fa-exclamation warn one" v-show="warnings[0]"></i>
          <i class="fas fa-exclamation warn two" v-show="warnings[1]"></i>
          <i class="fas fa-exclamation warn three" v-show="warnings[2]"></i>
          <i class="fas fa-exclamation warn four" v-show="warnings[3]"></i>
          <i class="fas fa-exclamation warn five" v-show="warnings[4]"></i>
          <i class="fas fa-exclamation warn six" v-show="warnings[5]"></i>
        </div>
        <div slot="terminal">
          <i class="fas fa-times terminal one" v-show="terminalX[0]"></i>
          <i class="fas fa-times terminal two" v-show="terminalX[1]"></i>
          <i class="fas fa-times terminal three" v-show="terminalX[2]"></i>
          <i class="fas fa-times terminal four" v-show="terminalX[3]"></i>
          <i class="fas fa-times terminal five" v-show="terminalX[4]"></i>
          <i class="fas fa-times terminal six" v-show="terminalX[5]"></i>
        </div>
      </dashboard>

      <ul class="locations">
        <li v-for="(item, index) in items.activity.locations" :style="{top: item.top + '%', left: item.left + '%'}">
          <img :src="'media/page3/' + item.img" />
          <p>{{item.name}}</p>
        </li>
      </ul>

      <div class="event" :style="{top: eventLocation[id].top + '%', left: eventLocation[id].left + '%'}" @click="event" v-show="showEvent && !terminal">
        <i class="fas fa-exclamation"></i>
      </div>

      <popup :id="id" @choose="choose" @tryAgain="tryAgain" @next="next" v-show="feedback"></popup>

    </div>

    <terminal-modal @tryAgain="replay" v-show="terminal"></terminal-modal>

    <!-- REVIEWS -->
    <review :choices="choices" @dashIndex="dashIndex" v-if="review">
      <dashboard :id="id" :dashValues="dashFinal[dashId]" :units="unitsFinal[dashId]">
        <div slot="warnings">
          <i class="fas fa-exclamation warn one" v-show="warningsFinal[dashId][0]"></i>
          <i class="fas fa-exclamation warn two" v-show="warningsFinal[dashId][1]"></i>
          <i class="fas fa-exclamation warn three" v-show="warningsFinal[dashId][2]"></i>
          <i class="fas fa-exclamation warn four" v-show="warningsFinal[dashId][3]"></i>
          <i class="fas fa-exclamation warn five" v-show="warningsFinal[dashId][4]"></i>
          <i class="fas fa-exclamation warn six" v-show="warningsFinal[dashId][5]"></i>
        </div>
      </dashboard>
    </review>
    <button-replay @replay="replay"></button-replay>
  </div>
</template>

<script>
import popup from './components/Popup.vue'
import dashboard from './components/Dashboard.vue'
import review from './components/Review.vue'
import terminalModal from './components/TerminalModal.vue'
import activate from './components/Animate.vue'
import buttonReplay from '../../../components/ButtonReplay.vue'
export default {
  data() {
    return {
      id: 0,
      dashId: 0,
      showEvent: false,
      active: false,
      kpiWarn: false,
      modal: true,
      feedback: false,
      final: false,
      review: false,
      dashValues: [8, 6, 15, 29, 71, 100],
      dashPrevValues: [8, 6, 15, 29, 71, 100],
      warnings: [false, false, false, false, false, false],
      terminalX: [false, false, false, false, false, false],
      terminal: false,
      dashFinal: [],
      choice: null,
      choices: [],
      units: {
        "hand": "1,000,014 units",
        "planned": "600, 014 units"
      },
      prevUnits: {
        "hand": "1,000,014 units",
        "planned": "600, 014 units"
      },
      unitsFinal: [],
      warningsFinal: [],
      eventLocation: [
        {
          top: 46,
          left: 55
        },
        {
          top: 35,
          left: 30
        },
        {
          top: 40,
          left: 48
        },
        {
          top: 53,
          left: 8
        },
        {
          top: 51,
          left: 46
        },
        {
          top: 64,
          left: 21
        }
      ]
    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    },
    backBtn() {
      return this.$store.state.backBtn
    },
    contBtn() {
      return this.$store.state.contBtn
    }
  },

  watch: {
    kpiWarn() {
      if(this.kpiWarn) {
        setTimeout(() => {
          this.kpiWarn = false
          console.log('falsey!')
        }, 5000);
      }
    },
    feedback() {
      window.screen.width < 750 && this.feedback == true ? this.$store.commit("backFalse") : this.$store.commit("backTrue")
    }
  },

  methods: {
    closeModal() {
      this.modal = false
      this.showEvent = true
    },
    event() {
      this.feedback = true
      this.showEvent = false
    },
    choose(payload) {
      // this.dashValues = this.items.activity.scenes[this.id].options[payload].gaugeVals
      this.dashValues[0] += this.items.activity.scenes[this.id].options[payload].gaugeVals[0]
      this.dashValues[1] += this.items.activity.scenes[this.id].options[payload].gaugeVals[1]
      this.dashValues[2] += this.items.activity.scenes[this.id].options[payload].gaugeVals[2]
      this.dashValues[3] = this.items.activity.scenes[this.id].options[payload].gaugeVals[3]
      this.dashValues[4] = this.items.activity.scenes[this.id].options[payload].gaugeVals[4]
      this.dashValues[5] = this.items.activity.scenes[this.id].options[payload].gaugeVals[5]
      this.units = this.items.activity.dashboard.inventoryVals[this.id + 1]
      this.choice = payload
      this.dashLook();
      this.termWarn();
    },
    tryAgain() {
      this.dashValues = [];
      this.dashValues = this.dashValues.concat(this.dashPrevValues);
      this.units = this.prevUnits
      this.kpiWarn = false
      this.dashLook();
      this.termWarn();
    },
    next() {
      this.active = true
      this.dashPrevValues = [];
      this.dashPrevValues = this.dashPrevValues.concat(this.dashValues);
      this.prevUnits = this.units
      this.feedback = false
      var dashboard = []
      dashboard = dashboard.concat(this.dashValues)
      this.dashFinal = this.dashFinal.concat([dashboard]);
      this.unitsFinal = this.unitsFinal.concat(this.units);
      var warn = []
      warn = warn.concat(this.warnings)
      this.warningsFinal = this.warningsFinal.concat([warn]);
      this.choices = this.choices.concat(this.choice);
      this.termShow();
      if(this.id === 5) {
        this.showEvent = false
        this.final = true
        setTimeout(() => {
          this.active = false
        }, 2200);
      } else {
        this.id += 1
        setTimeout(() => {
          this.showEvent = true
          this.active = false
        }, 2200);
      }
    },
    showReview() {
      this.review = true
      this.final = false
      this.$store.commit('backFalse');
      this.$store.commit('replayTrue');
    },
    dashIndex(num) {
      this.dashId = num
    },
    replay() {
      this.id = 0
      this.dashId = 0
      this.showEvent = false
      this.kpiWarn = false
      this.modal = true
      this.feedback = false
      this.final = false
      this.review = false
      this.dashValues = [8, 6, 15, 29, 71, 100]
      this.dashPrevValues = [8, 6, 15, 29, 71, 100]
      this.warnings = [false, false, false, false, false, false],
      this.terminalX = [false, false, false, false, false, false],
      this.terminal = false,
      this.dashFinal = []
      this.choice = null
      this.choices = []
      this.units = {
        "hand": "1,000,014 units",
        "planned": "600, 014 units"
      },
      this.prevUnits = {
        "hand": "1,000,014 units",
        "planned": "600, 014 units"
      },
      this.unitsFinal = []
      this.warningsFinal = []
      this.$store.commit('backTrue');
      this.$store.commit('replayFalse');
    },
    dashLook() {
      if(this.dashValues[0] >= this.items.activity.dashboard.gaugeWarn[0]) {
        this.kpiWarn = true
        this.warnings[0] = true
      } else {
        this.warnings[0] = false
      }
      if(this.dashValues[1] >= this.items.activity.dashboard.gaugeWarn[1]) {
        this.kpiWarn = true
        this.warnings[1] = true
      } else {
        this.warnings[1] = false
      }
      if(this.dashValues[2] >= this.items.activity.dashboard.gaugeWarn[2]) {
        this.kpiWarn = true
        this.warnings[2] = true
      } else {
        this.warnings[2] = false
      }
      if(this.dashValues[3] >= this.items.activity.dashboard.gaugeWarn[3]) {
        this.kpiWarn = true
        this.warnings[3] = true
      } else {
        this.warnings[3] = false
      }
      if(this.dashValues[4] <= this.items.activity.dashboard.gaugeWarn[4]) {
        this.kpiWarn = true
        this.warnings[4] = true
      } else {
        this.warnings[4] = false
      }
      if(this.dashValues[5] <= this.items.activity.dashboard.gaugeWarn[5]) {
        this.kpiWarn = true
        this.warnings[5] = true
      } else {
        this.warnings[5] = false
      }
      console.log(this.items.activity.dashboard.gaugeWarn[0] + "," + this.items.activity.dashboard.gaugeWarn[1] + "," + this.items.activity.dashboard.gaugeWarn[2] + "," + this.items.activity.dashboard.gaugeWarn[3] + "," + this.items.activity.dashboard.gaugeWarn[4] + "," + this.items.activity.dashboard.gaugeWarn[5])
    },
    termWarn() {
      this.dashValues[0] >= this.items.activity.dashboard.terminalVal[0] ? this.terminalX[0] = true : this.terminalX[0] = false

      this.dashValues[1] >= this.items.activity.dashboard.terminalVal[1] ? this.terminalX[1] = true : this.terminalX[1] = false

      this.dashValues[2] >= this.items.activity.dashboard.terminalVal[2] ? this.terminalX[2] = true : this.terminalX[2] = false

      this.dashValues[3] >= this.items.activity.dashboard.terminalVal[3] ? this.terminalX[3] = true : this.terminalX[3] = false

      this.dashValues[4] <= this.items.activity.dashboard.terminalVal[4] ? this.terminalX[4] = true : this.terminalX[4] = false

      this.dashValues[5] <= this.items.activity.dashboard.terminalVal[5] ? this.terminalX[5] = true : this.terminalX[5] = false

    },
    termShow() {
      const id1 = this.dashValues[0] >= this.items.activity.dashboard.terminalVal[0]
      const id2 = this.dashValues[1] >= this.items.activity.dashboard.terminalVal[1]
      const id3 = this.dashValues[2] >= this.items.activity.dashboard.terminalVal[2]
      const id4 = this.dashValues[3] >= this.items.activity.dashboard.terminalVal[3]
      const id5 = this.dashValues[4] <= this.items.activity.dashboard.terminalVal[4]
      const id6 = this.dashValues[5] <= this.items.activity.dashboard.terminalVal[5]
      id1 || id2 || id3 || id4 || id5 || id6 ? this.terminal = true : null
    },
    checkCue() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      // var self = this
      // if(Math.floor(self.$refs.audio1.currentTime) == 3){
      //   self.vis1 = "visible"
      // }
    },
    runInterval() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      this.interval = setInterval(this.checkCue, 100);
    }
  },
  mounted() {
    //JIRA POSITIONING
    this.$store.commit("scormLMS/changeUserLocation", "MA KPIs: Page 6");
    this.$store.state.game ? this.$store.commit('contTrue') : this.$store.commit('contFalse');
    this.$store.commit('backTrue');

  },
  beforeDestroy() {
    //BOILERPLATE FOR RUNNING AN INTERVAL
    clearInterval(this.interval);
  },
  components: {popup, dashboard, review, terminalModal, activate, buttonReplay},
  props: []
};
</script>

<style scoped>
svg {
  width: 48%;
  margin-top: 13.5%;
  margin-left: 9.5%;
}
.st0{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}
.st1{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;stroke-dasharray:1.9893,1.9893;}
.st2{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;stroke-dasharray:2;}
@media only screen and (max-width: 737px) {
  svg {
    width: 45%;
    margin-top: 19.8%;
    margin-left: 13.5%;
  }
}
</style>



// WEBPACK FOOTER //
// Page6.vue?88f3643c